import Input from 'library/components/form/input';
import { Content } from './styles';
import withFormContainer from './hocs/with-form-container';

const InputModal = ({ fieldKey = 'name', isFocusedOnMount = false, ...props }) => {
  return (
    <Content>
      <Input {...props} required name={fieldKey} isFocusedOnMount={isFocusedOnMount} />
    </Content>
  );
};

export default withFormContainer(InputModal);
